import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    mapPolicyGeneralInformation,
    mapBillingInformation,
    mapPaymentInformation,
    mapContactPreferences,
    mapCoverages,
    mapValuables,
    mapDiscounts,
    mapSurcharges,
    mapFees,
    mapClaims,
} from './policy-mapper';
import { SelectionService } from '../selection.service';
import { LoadingService } from 'src/app/shared/loading.service';
import { APP_CONFIG, AppConfig } from 'src/app.config';
import { Inject } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PolicySnapshotService {
    constructor(
        private httpClient: HttpClient,
        private selectionService: SelectionService,
        private loadingService: LoadingService,
        @Inject(APP_CONFIG) private config: AppConfig
    ) {}

    addNotesAPI(body: any): Observable<any> {
        const headers = new HttpHeaders({ 'x-api-key': this.config.policyOrchestratorApiKey });
        return this.httpClient.post(this.config.policyOrchestratorUrl, body, { headers });
    }

    mapApiToFieldsJson(apiData: any, policyNumber: string): any[] {
        if (!apiData || typeof apiData !== 'object') {
            return [];
        }

        const policyKey = Object.keys(apiData).find(
            (key) =>
                apiData[key]?.policySnapshot?.policyGeneralInformation?.policyNumber?.value?.toLowerCase() ===
                policyNumber.toLowerCase()
        );

        if (!policyKey) {
            return [];
        }

        const snapshot = apiData[policyKey].policySnapshot;

        if (!snapshot || typeof snapshot !== 'object') {
            return [];
        }

        const mappedSections: any[] = [];

        snapshot.policyGeneralInformation &&
            mappedSections.push(mapPolicyGeneralInformation(snapshot.policyGeneralInformation));

        snapshot.paymentInformation && mappedSections.push(mapPaymentInformation(snapshot.paymentInformation));

        mappedSections.push(mapBillingInformation(snapshot.billingInformation ?? []));

        snapshot.contactPreferences && mappedSections.push(mapContactPreferences(snapshot.contactPreferences));

        snapshot.coverages && mappedSections.push(mapCoverages(snapshot.coverages));

        snapshot.valuables && mappedSections.push(mapValuables(snapshot.valuables));

        snapshot.discounts && mappedSections.push(mapDiscounts(snapshot.discounts));

        mappedSections.push(mapSurcharges());
        mappedSections.push(mapFees());
        mappedSections.push(mapClaims(snapshot.claims ?? []));

        return mappedSections;
    }
}
